function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("rect", {
  x: 3,
  y: 3,
  width: 18,
  height: 18,
  rx: 2,
  stroke: "#4D4D4D",
  strokeWidth: 1.5
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M9.444 8.5h7.5m0 0l-2.5-2.444m2.5 2.444l-2.5 2.444m0 4.556h-7.5m0 0l2.5 2.444m-2.5-2.444l2.5-2.444",
  stroke: "#4D4D4D",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgProcess(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}

export default __webpack_public_path__ + "/img/process.svg";
export { SvgProcess as ReactComponent };